import { SafeHtml } from "@angular/platform-browser";
import { ResourceType, SectionType, TableType } from "../util/soap-config.constants";

export interface TitleValue {
  title: string, value: string, unit?: string
}

export interface SnomedCodes {
  snomedCode: string,
  snomedDisplay: string,
  snomedCategory?: string
}

export interface InternalSection {
  type: TableType,
  name: string
}

export interface VerticalUserInputs extends TitleValue {
  type: SectionType,
  required?: boolean
  data?: Array<string>
}

export type HorizontalUserInputs = Array<{ value: string }>;

export interface HorizontalHeaders {
  title: string, type: SectionType, data?: Array<string>, required?: boolean, value?: string
}

export interface Resource {
  id: number;
  title: string;
  type?: ResourceType;
  tableType: TableType;
  checked?: boolean;
}

export interface SoapItem {
  type: ResourceType,
  color: string,
  resources: Resource[]
}

export interface CheckBoxObject {
  id?: number,
  checked?: boolean,
  title: string,
  tableType: TableType
}
export enum sectionName {
  subjective = "subjective",
  objective = "objective",
  plan = "plan",
  assessment = "assessment"
}

export interface SoapNote {
  "uid"?: string
  "tempUid"?: string
  "appointmentId": string
  [sectionName.subjective]: string | SafeHtml
  [sectionName.objective]: string | SafeHtml
  [sectionName.assessment]: string | SafeHtml
  [sectionName.plan]: string | SafeHtml
  "patientId": string
  "soapNoteDate": string
  "practitionerId": string,
  "templateType": string,
  "isCustomTemplate"?: boolean
}

export interface AddtionalParams {
  sectionIndex: number,
  subSectionIndex: number,
  index: number,
  column: number
}

export interface DraftNote {
  [key: string]: {
    section: DraftSection;
    notes: string;
    userInputs: Array<VerticalUserInputs> | Array<HorizontalUserInputs>;
    isTableEnabled?: boolean;
    showTable?: boolean;
  };
}
export interface DraftSection {
  type: TableType;
  name: string;
  header: string;
}


export interface Vital {
  "Blood Pressure": string;
  "Heart Rate": string;
  "Oxygen": string;
  "Temperature": string;
  "Height": string;
  "Weight": string;
  "Body Mass Index": string;
  "Respiratory Rate": string;
  "Smoking Cessation": string;
  "Alcohol Cessation": string;
}

export interface VitalBody {
  vitals: { key: string, value: string }[]
  "vitalDate": string,
  "practitionerId": string,
  "patientId": string
}

export interface Vitals {
  "Body_Temperature": string;
  "Heart_Rate": string;
  "Systolic_Blood_Pressure": string;
  "Diastolic_Blood_Pressure": string;
  "Oxygen_Saturation": string;
  "Body_Height": string;
  "Body_Weight": string;
  "Body_Mass_Index": string;
  "Respiratory_Rate": string;
}

export interface GenerateVitalsResponse {
  "suspicious_patterns": string[];
  "vitals": {
    "vitals": Vitals;
  };
}

export type ResponseObject = { [key: string]: ResponseValueType; };
export type ResponseValueType =
  | string
  | number
  | ResponseValueType[]
  | ResponseObject;
export type GeneratedSoapNoteResponse = {
  [key: string]: ResponseValueType;
}

export interface SoapSetting {
  active: SoapItem[];
  pending: CheckBoxObject[];
}


export interface MedicalRequestTableEntry {
  medication: string;
  duration: string;
  qty: string;
  route: string;
  instruction: string;
}

export interface MedicalRequestEntry {
  date: string;
  table: MedicalRequestTableEntry[];
}
